(ns frontend.view.grid.oppos-grid.columns
  (:require
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(def alj-pmo-pipeline-kanban-fields
  [:oppo/stage
   :oppo/pmo-project-type
   :oppo/project-description
   :oppo/bu-lead
   :oppo/group-business-units
   :oppo/internal-department
   :oppo/cmt
   :oppo/project-start-date
   :oppo/project-end-date
   :oppo/status-and-next-steps
   :oppo/project-notes
   :oppo/priority
   :oppo/rank
   :oppo/date-project-completion
   :common/updated-on])

(def default-alj-columns
  [:oppo/name
   :oppo/group-business-units
   :oppo/status
   :oppo/stage
   :oppo/target-asset
   :oppo/tag-deal-type
   [:oppo/target-asset :asset/tag-industry]
   :oppo/tag-segment
   [:oppo/target-asset :company/tag-category]
   :oppo/deal-description
   [:oppo/target-asset :company/product-service]
   :oppo/distribution-terms
   [:oppo/target-asset :asset/country]
   :oppo/regions
   [:oppo/target-asset :fof-asset/tag-vintage-year]
   [:oppo/target-asset :fof-asset/cur-target-size]
   :oppo/partner
   :oppo/funding-round-v2
   :oppo/cur-target-size
   :oppo/cur-total-project-investment
   :oppo/cur-total-project-investment--sym
   [:oppo/target-asset :asset/year-project-funded]
   :oppo/cur-pre-money
   :oppo/cur-ticket
   :oppo/cur-ticket--sym
   ;:oppo/cur-alj-investment
   :oppo/cur-enterprise-value
   :oppo/target-stake-percentage
   [:oppo/target-asset :fof-asset/fund-life]
   [:oppo/target-asset :fof-asset/exit-terms]
   :oppo/esg-impact
   ;:oppo/expected-irr
   :oppo/expected-net-irr
   [:oppo/target-asset :fof-asset/management-fee]
   [:oppo/target-asset :fof-asset/carried-interest]
   [:oppo/target-asset :fof-asset/carried-interest-details]
   :oppo/payback-time
   :oppo/lead-source-v2
   :oppo/alj-SBDI-lead
   ;:oppo/owner
   :oppo/bu-lead
   :oppo/date-CIC-presentation
   :oppo/CIC-recommendation
   :oppo/CIC-notes
   :oppo/datetime-alj-deadline-to-close-deal
   :oppo/status-and-next-steps
   :oppo/net-margin
   [:oppo/target-asset :company/website]
   [:oppo/target-asset :fof-asset/website]])

(def alj-kanban-fields
  (let [tenant-schema @session/tenant-schema
        pass-reason-index (inc (cu/index-of default-alj-columns :oppo/status))]
    (->> (concat (subvec default-alj-columns 0 pass-reason-index)
                 [:oppo/pass-reason-v2]
                 (subvec default-alj-columns pass-reason-index))
         (remove #{:oppo/name :oppo/group-business-units :oppo/stage})
         (remove (fn [c]
                   (let [{:keys [field/data-type]}
                         (registry/get-field-schema tenant-schema (if (keyword? c) c (last c)))]
                     (= data-type :data.type/currency-symbol))))
         (vec))))

(def not-available
  #{:oppo/attachments
    :oppo/ratings
    ;;TODO if we want to use these, we should add these as attributes to each deal-entity:
    :role/guest-buy-side})

;;default set of selected columns
(def ordered-default-columns
  [:oppo/name
   :oppo/cur-ticket
   :oppo/stage
   :oppo/status
   :oppo/status-and-next-steps
   :oppo/owner])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:oppo/name})

(def my-deals-ordered-columns
  [:oppo/name
   :oppo/cur-ticket
   :oppo/stage
   :oppo/status
   :oppo/status-and-next-steps])

(def my-deals-columns
  (set my-deals-ordered-columns))

(def passed-deals-ordered-columns
  [:oppo/name
   :oppo/cur-ticket
   :oppo/stage
   :oppo/passed-on
   :oppo/pass-reason-v2
   :oppo/last-pass-comment
   :oppo/owner])

(def passed-deals-columns
  (set passed-deals-ordered-columns))

(def deals-on-hold-ordered-columns
  [:oppo/name
   :oppo/cur-ticket
   :oppo/stage
   :oppo/put-on-hold-on
   :oppo/on-hold-until
   :oppo/last-hold-comment
   :oppo/owner])

(def deals-on-hold-columns
  (set deals-on-hold-ordered-columns))

(def new-deals-this-q-ordered-columns
  [:oppo/name
   :oppo/cur-ticket
   :oppo/stage
   :oppo/status
   :oppo/status-and-next-steps
   :oppo/owner])

(def new-deals-this-q-columns
  (set new-deals-this-q-ordered-columns))

(def deal-progress-ordered-columns
  [:oppo/name
   :oppo/target-asset
   :asset/description
   :oppo/deal-description
   :oppo/stage
   :oppo/age-in-days-active])

(def deal-progress-columns
  (set deal-progress-ordered-columns))
